import state from './moduleJournalState.js'
import mutations from './moduleJournalMutations.js'
import actions from './moduleJournalActions.js'
import getters from './moduleJournalGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
